@if(collapsible && orientation === 'vertical') {
  <div class="tab-vertical tab-vertical-collapsible" [class.sidebar-collapsed]="sidebarCollapsed">
    <div class="collapsible-sidebar">
      <div class="sidebar-header">
        @if(!sidebarCollapsed && sidebarLabel) {
          <span class="sidebar-label">{{ sidebarLabel }}</span>
        }
        <button class="sidebar-toggle-btn" type="button" (click)="toggleSidebar()" [title]="sidebarCollapsed ? 'Expand' : 'Collapse'">
          <i class="fa-solid" [class.fa-angles-left]="!sidebarCollapsed" [class.fa-angles-right]="sidebarCollapsed"></i>
        </button>
        <button class="sidebar-mobile-toggle" type="button" (click)="showMobileMenu = !showMobileMenu">
          @for(tab of tabs; track tab.id) {
            @if(tab.id === activeId) {
              @if(tab.titleTpl?.templateRef) {
                <ng-template [ngTemplateOutlet]="tab.titleTpl.templateRef"></ng-template>
              } @else {
                <i *ngIf="tab.icon" class="{{ tab.icon }} sidebar-nav-icon"></i>
                <span class="sidebar-mobile-toggle-label">{{ tab.title }}</span>
              }
            }
          }
          <i class="fa-solid sidebar-mobile-toggle-chevron" [class.fa-chevron-down]="!showMobileMenu" [class.fa-chevron-up]="showMobileMenu"></i>
        </button>
      </div>
      <nav class="sidebar-nav" [class.mobile-open]="showMobileMenu">
        @for(tab of tabs; track tab.id; let i = $index) {
          @if(startsSection(i)) {
            @if(sidebarCollapsed) {
              @if(i > 0) {
                <span class="sidebar-section-divider" aria-hidden="true"></span>
              }
            } @else {
              <span class="sidebar-section-label">{{ tab.section }}</span>
            }
          }
          @if(tab.link) {
            <a class="sidebar-nav-item" [routerLink]="tab.link" [title]="tab.title" (click)="showMobileMenu = false">
              <ng-container *ngTemplateOutlet="sidebarNavItemContent; context: { $implicit: tab }"></ng-container>
              @if(!sidebarCollapsed) {
                <i class="fa-solid fa-arrow-up-right-from-square sidebar-nav-link-icon" aria-hidden="true"></i>
              }
            </a>
          } @else {
            <button
              type="button"
              class="sidebar-nav-item"
              [class.active]="tab.id === activeId"
              [disabled]="tab.disabled"
              (click)="select(tab.id)"
              [title]="tab.title"
            >
              <ng-container *ngTemplateOutlet="sidebarNavItemContent; context: { $implicit: tab }"></ng-container>
            </button>
          }
        }
      </nav>
    </div>
    <div class="collapsible-content">
      <ng-container [ngTemplateOutlet]="tabsetHeader"></ng-container>
      @for(tab of tabs; track tab.id) {
        @if(tab.id === activeId || !destroyOnHide) {
          <div [hidden]="tab.id !== activeId">
            <ng-template [ngTemplateOutlet]="tab.contentTpl?.templateRef || null"></ng-template>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <ng-container [ngTemplateOutlet]="tabsetHeader"></ng-container>
  <div [ngClass]="{'tab-vertical': orientation === 'vertical'}">
    @if(orientation === 'vertical'){
      <div class="tab-mobile-select" (click)="showMobileMenu = !showMobileMenu">
        @if(activeTabTitle){
          @if(activeTabTitle.isTemplate){
            <ng-template [ngTemplateOutlet]="activeTabTitle.content"></ng-template>
          }@else{
            {{activeTabTitle.content}}
          }
        }
        <div class="select-tab-icon">
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    }

    <ul
      ngbNav
      #nav="ngbNav"
      [class]="'nav-tabs ' + justifyClass"
      [activeId]="activeId"
      [destroyOnHide]="destroyOnHide"
      [orientation]="orientation"
      (navChange)="onNavChange($event)"
      [animation]="false"
      [class.tab-mobile-menu]="showMobileMenu"
    >
      <li *ngFor="let tab of contentTabs" [ngbNavItem]="tab.id" [disabled]="tab.disabled">
        <button ngbNavLink type="button" class="btn btn-link">
          <i *ngIf="tab.icon" class="{{ tab.icon }} mr-2"></i>
          <span>{{ tab.title }}</span>
          <ng-template [ngTemplateOutlet]="tab.titleTpl?.templateRef || null"></ng-template>
        </button>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="tab.contentTpl?.templateRef || null"></ng-template>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
}

<!-- Content marked with libGungTabsetHeader stays visible above the tab content, whichever tab is active -->
<ng-template #tabsetHeader>
  <ng-content select="[libGungTabsetHeader]"></ng-content>
</ng-template>

<ng-template #sidebarNavItemContent let-tab>
  @if(sidebarCollapsed) {
    <!-- collapsed: icon only -->
    <i *ngIf="tab.icon" class="{{ tab.icon }} sidebar-nav-icon"></i>
    <i *ngIf="!tab.icon" class="fa-solid fa-circle sidebar-nav-icon sidebar-nav-icon--placeholder"></i>
  } @else {
    <!-- expanded: use titleTpl if available, otherwise icon + title string -->
    @if(tab.titleTpl?.templateRef) {
      <ng-template [ngTemplateOutlet]="tab.titleTpl.templateRef"></ng-template>
    } @else {
      <i *ngIf="tab.icon" class="{{ tab.icon }} sidebar-nav-icon"></i>
      <span class="sidebar-nav-label">{{ tab.title }}</span>
    }
  }
</ng-template>
